<template>
  <div>
    <!-- <div><img :src="firstBanner" alt="" width="100%"></div> -->
    <h3 style="font-size:20px;padding-top:10px;color:#e04683">欢迎登录展商服务平台！</h3>
    <el-card class="box-card">
      <div style="display:flex;">
        <div style="width:40%">
          <div class="text item"><span class="nameText">公司名称</span> <span>{{ userInfo.atrName }}</span></div>
          <div class="text item"><span class="nameText" style="letter-spacing:5px">展位号</span><span>{{ userInfo.bthCode || '暂无' }}</span></div>
          <!--<div class="text item"><span class="nameText">展位面积</span>

            <template v-if="userInfo.bthArea">
             <span>{{userInfo.bthArea}} m<sup>2</sup></span>
            </template>
            <template v-else>
            <span>暂无</span>
            </template>
         
          </div>
          <div class="text item"><span class="nameText">展位类型</span> <span>{{ userInfo.bthType || '暂无' }}</span></div>-->
        </div>
        <!--<div>
          <div class="text item"><span class="nameText">客户经理</span><span>{{ userInfo.atrSaleName || '暂无' }}</span></div>
          <div class="text item"><span class="nameText">电<span style="display:inline-block;width:28px"></span>话</span><span>{{ userInfo.atrTel || '暂无' }}</span></div>
          <div class="text item"><span class="nameText">邮<span style="display:inline-block;width:28px"></span>箱</span><span>{{ userInfo.atrEmail || '暂无' }}</span></div>
        </div>-->
 

      </div>
   
    </el-card>
    <ul>
      <li>
        <p style="margin-bottom: 10px;">欢迎您参加<strong>第二十一届中国（上海）国际乐器展览会（Music China 2024）！</strong></p>
        <p style="margin-bottom: 10px;">我们希望展商登录服务平台内所包含的信息能帮助贵公司顺利地完成参加<strong>第二十届中国（上海）国际乐器展览会</strong>的各项准备工作。 服务平台内涵盖了所有展商手册中所有信息以及回执表等， 并设置了网上展览（常年开放）以及观众邀请等功能 。我们会尽可能地完善服务平台内信息， 若您发现有任何问题，请立即与我们联系，以便我们及时更正。</p>
        <p style="margin-bottom: 10px;">请您仔细浏览展商服务平台，并按照里面的要求回复有关回执，并在截止日期前传真到主办单位及相关服务单位，它将帮助您作好参展准备。</p>
        <p style="margin-bottom: 10px;">展商服务平台并不完全取代主办单位和主场承包商的所有服务，对贵公司的其它有关要求，我们会尽可能提供帮助。</p>
        <p style="margin-bottom: 20px;">如果您对展商服务平台提供的服务有任何疑问，请与组委会办公室联系。</p>
        <!--<ol style="font-weight:bold;padding:16px 0">
          <li @click="toLink('/magezine')">1.会刊信息</li>
          <li @click="toLink('/product')">2.主要产品</li>
          <li @click="toLink('/card')">3.参展证申请</li>
          <li @click="toLink('/inviteCode')">4.企业名片</li>
          <li @click="toLink('/hotel')">5.酒店预定</li>
        </ol>-->
        <p style="margin-bottom: 20px;">
          <strong>上海国展展览中心有限公司<br/>
                          地      址：上海市娄山关路55号新虹桥大厦11楼(200336)<br/>
                          联 系 人：戎晓娴 房瑾 施先之 夏亦南 任浩 王翔 周冰竹<br/>
                          电      话：021-62956677<br/>
                           传      真：021-62780038<br/>
                           电子邮件：rongxiaoxian@shanghai-intex.com; shixianzhi@shanghai-intex.com<br/>
                           网      址：www.musicchina-expo.com</strong>
        </p>
      </li>
      <li>为确保您顺利参展，请阅读平台相关信息，并遵守各项服务的截止日期，部分标有“必填”字样的内容请优先填写。如有任何疑问，请与您的客户经理联系，我们将竭诚为您提供更详尽的服务和指导。</li>
      <li>我们期待着您的到来。祝您在展会上取得成功！</li>
      <li style="color:red">为确保信息更新成功，请在做出修改后即刻点击保存按钮，若60分钟未操作，系统将自动退出</li>
      <br />
      <div class="imporTip">今天是{{ today }}， 距离展会开幕还有 {{ inDays }} 天。</div>
    </ul>
    <el-divider></el-divider>
    <el-table :data="infoTable" style="width: 100%;padding-bottom:150px"  stripe>
      <el-table-column prop="fstName" label="项目" align="center">
        <template slot-scope="scope">
          <span @click="tableLink(scope.row)" style="cursor: pointer">{{ scope.row.fstName == '产品类别' ? '主要产品': scope.row.fstName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="重要性" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fstName == '会刊登记及展品分类'" style="color:red">{{formStatua.Catalog ? '（已填写）' : '（必填）'}}</span>
          <span v-else-if="scope.row.fstName == '参展商代表证'" style="color:red">{{formStatua.Ticket ? '（已填写）' : '（必填）'}}</span>
          <span v-else-if="scope.row.fstName == '标准展位楣板'" style="color:red">{{formStatua.Lintel ? '（已填写）' : '（标摊必填）'}}</span>
          <span v-else-if="scope.row.fstName == '展览会现场知识产权保护通知'" style="color:red">{{formStatua.know ? '（已填写）' : '（必填）'}}</span>
          <span v-else-if="scope.row.fstName == '展台音量规定'" style="color:red">{{formStatua.sound ? '（已填写）' : '（必填）'}}</span>
          <span v-else-if="scope.row.fstName == '展品上传'" style="color:red">{{formStatua.sound ? '（已填写）' : '（必填）'}}</span>
          <!--<span v-else style="color:red">{{ scope.row.isRequired ? '必填项' : '非必填' }}</span>-->
        </template>
      </el-table-column>

      <el-table-column prop="fstEDate" label="截止日期" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fstName == '专业观众免费参观证'">2024-08-31</span>
          <span v-else-if="scope.row.fstName == 'VIP观众嘉宾邀请'">2024-08-31</span>
          <span v-else>{{ format(scope.row.fstEDate) }}</span>
          <!--<span v-if="scope.row.fstName == '参展证申请' || scope.row.fstName == '会刊信息' || scope.row.fstName == '楣板信息' || scope.row.fstName == '新品上传'">2024-08-10</span>-->
          <!--<span v-if="scope.row.fstName == '会刊信息'">特别提示：印刷版的会刊内容提交和修改已于1月15日截止，截止日期后提交或修改的会刊内容，将会收录在电子会刊中！</span>
          <span v-if="scope.row.fstName == '产品类别'">特别提示：印刷版的会刊内容提交和修改已于1月15日截止，截止日期后提交或修改的主要产品，将会收录在电子会刊中！</span>-->
        </template>
      </el-table-column>
      <!--<el-table-column prop="subDate" label="提交日期" align="center">
        <template slot-scope="scope">
          <span>{{ format(scope.row.subDate) }}</span>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import moment from 'moment'
import firstBanner from '@/assets/firstBanner.jpg'
import tools from '@/utils/tools';
moment.locale('zh-cn')
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      exhInfo: {},
      today: moment().format('YYYY年MM月DD日'),
      inDays: '',
      infoTable: [{
        fstName:'会刊登记及展品分类',
        fstEDate:'2024-08-10'
      },{
        fstName:'参展商代表证',
        fstEDate:'2024-08-10'
      },{
        fstName:'标准展位楣板',
        fstEDate:'2024-08-10'
      },{
        fstName:'展览会现场知识产权保护通知',
        fstEDate:'2024-08-10'
      },{
        fstName:'展台音量规定',
        fstEDate:'2024-08-10'
      },{
        fstName:'专业观众免费参观证',
        fstEDate:'2024-08-10'
      }],
      firstBanner:firstBanner,
      formStatua: {
        Ticket: false,
        Catalog: false,
        Lintel: false,
        know: false,
        sound: false
      }
    }
  },
  mounted() {
    this.GetActorForm()
    var _know = sessionStorage.getItem('knowwrap') || ''
    var _sound = sessionStorage.getItem('soundwrap') || ''
    if (_know === 'know') {
      this.formStatua.know = true
    }
    if (_sound === 'sound') {
      this.formStatua.sound = true
    }
    api.getexhinfo().then((res) => {
      // this.inDays = moment(res.data.data.exhbtime).toNow(true)

      this.inDays = moment(res.data.data.exhbtime).diff(new Date(), 'day')

      // console.log(moment(res.data.data.exhbtime).diff(new Date(), 'month','day'))
      // console.log(moment('2024-03-01 00:00:00').diff(new Date(), 'month','day'))
      

    })
    api.getformsetting().then((res) => {
      var _temp = res.data.data
//    this.infoTable =  _temp.sort(function(data1,data2){
//      if(new Date(data1.fstEDate).getTime() > new Date(data2.fstEDate).getTime()){
//        return 1
//      }else{
//        return -1
//      }
//    })
//    this.infoTable = this.infoTable.splice(10,4)
      // this.infoTable = _temp
      // console.log(this.infoTable )

    })
  },
  methods: {
    GetActorForm () {
      api.GetActorForm({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.length > 0) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].atrStatType === 'Ticket') {
              if (res.data[i].submitCount !== '' && parseInt(res.data[i].submitCount) > 0) {
                this.formStatua.Ticket = true
              }
            }
            if (res.data[i].atrStatType === 'Catalog') {
              if (res.data[i].submitCount !== '' && parseInt(res.data[i].submitCount) > 0) {
                this.formStatua.Catalog = true
              }
            }
            if (res.data[i].atrStatType === 'Lintel') {
              if (res.data[i].submitCount !== '' && parseInt(res.data[i].submitCount) > 0) {
                this.formStatua.Lintel = true
              }
            }
          }
        }
      })
    },
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    toLink(url){
      // console.log(url)
      this.$router.push(url)
    },
    tableLink(obj){
      var url = ''
      if(obj.fstName == '会刊登记及展品分类'){
        alert('会刊服务已截止提交，网上展厅以及导览信息请在网上基本信息模块完善。')
//      url = '/magezine'
      }
      if(obj.fstName == '参展商代表证'){
        url = '/card'
      }
      if(obj.fstName == '标准展位楣板'){
        url = '/boardInfo'
      }
      if(obj.fstName == '展览会现场知识产权保护通知'){
        url = '/knowledge'
      }
      if(obj.fstName == '展台音量规定'){
        url = '/sound'
      }
      if(obj.fstName == '专业观众免费参观证'){
        url = '/inviteFree'
      }
      this.$router.push(url)
    }
  }

}
</script>

<style lang="less" scoped>
.box-card {
  margin: 20px 0 20px 0;
}
.item {
  padding: 10px 0;
  font-size:14px
}
.item .nameText{
  font-weight: normal;
  display: inline-block;
  width:60px;
  text-align:right;
  margin-right: 10px;
}
.item span{
  font-weight: bold;
}
li, strong {
  line-height: 2;
  font-size:14px;
}
.page-warp h3{
  font-size:14px
}
.imporTip{
  padding:10px 20px;font-size:18px;color:#00ad48;font-weight: bold;
  background: #d0eadb linear-gradient(135deg, #d0eadb 0%, #fff 100% );
  border-radius:10px;
}
li{
  cursor: pointer;
}
@media screen and (max-width:540px){

}
</style>
